import { Icon, Intent } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { IPETest, PE_TEST_QUESTION_TYPE } from "src/modules/pe-tests-module/data/interfaces"
import { ITestsStore, useTestsStore } from "src/modules/pe-tests-module/data/store"
import { ITestProps } from "../SingleTest"
import MultiChoiceListResult from "./MultiChoiceListResult"
import RangeListResult from "./RangeListResult"

/* Protopia Ecosystem component */
export interface IListResultProps {
   
}
const ListResults = ({ item, ...props }: ITestProps): JSX.Element => {
  const currentTest : IPETest  = useTestsStore((state:ITestsStore) => state.currentTest) 
  return <div className="pe-matching-results my-5 w-100">
    {
      currentTest.questions.map( (q, i) => {
        return <Result item={q} i={i} key={q.id} />
      })
    }
  </div>
}
export default ListResults

const Result = (props:any): JSX.Element => {
  switch(props.item.type) {
    case PE_TEST_QUESTION_TYPE.RANGE:
      return <RangeListResult item={props.item} i={props.i} />
    case PE_TEST_QUESTION_TYPE.MULTI_CHOOSE:
    default:
      return <MultiChoiceListResult item={props.item} i={props.i} />
  }
}